import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles/search-pins-menu';

import SearchFilterPins from './search_filter_pins';

const SearchFilterPinsMenu = ({ editable, searchFilters, submitSearchQuery }) => {
  const [showSearchPinsMenu, setShowSearchPinsMenu] = useState(false);
  const thisComponent = useRef();

  const handleInteractions = (e) => {
    if (e.key === 'Escape' || !thisComponent.current.contains(e.target)) {
      setShowSearchPinsMenu(false);
    }
  };

  const addEventListeners = () => {
    window.addEventListener('click', handleInteractions);
    window.addEventListener('keyup', handleInteractions);
  };

  const removeEventListeners = () => {
    window.removeEventListener('click', handleInteractions);
    window.removeEventListener('keyup', handleInteractions);
  };

  useEffect(() => {
    if (showSearchPinsMenu) {
      addEventListeners();
    } else {
      removeEventListeners();
    }

    return () => {
      removeEventListeners();
    };
  }, [showSearchPinsMenu]);


  return (
    <div className="search-pins-menu-wrapper" ref={thisComponent}>
      <button
        className={classnames(
          "button",
          "secondary",
          "search-pins-menu-button",
          { active: showSearchPinsMenu },
        )}
        onClick={() => setShowSearchPinsMenu(!showSearchPinsMenu)}
        type="button"
      >
        <span className="bff-pin" />
        {searchFilters.length}
      </button>
      {showSearchPinsMenu && (
        <SearchFilterPins
          editable={editable}
          searchFilters={searchFilters}
          setShowSearchPinsMenu={setShowSearchPinsMenu}
          submitSearchQuery={submitSearchQuery}
        />
      )}
    </div>
  );
};

SearchFilterPinsMenu.propTypes = {
  editable: PropTypes.bool.isRequired,
  searchFilters: PropTypes.arrayOf(PropTypes.shape({})),
  submitSearchQuery: PropTypes.func.isRequired,
};

SearchFilterPinsMenu.defaultProps = {
  searchFilters: [],
};

export default SearchFilterPinsMenu;
